import ConsoleApi from "@/consoleapi/consoleApi";
import {AxiosResponse} from "axios";

/**
 *
 */
export default class RestcommStatics extends ConsoleApi {
    protected resource = '/restcomm/statics/calls';

    public get(accountId: string): Promise<AxiosResponse>{
        return this.axios.get(this.requestUri + this.getAccountResource(accountId), {
            headers: {
                Authorization: `Bearer ${this.bearerToken}`,
            }
        });
    }
}